import React, { createContext, useContext, useState } from 'react';

// Create context
const SelectedDateContext = createContext();

// Provider component
export const SelectedDateProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  return (
    <SelectedDateContext.Provider value={{ selectedDate, setSelectedDate }}>
      {children}
    </SelectedDateContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useSelectedDate = () => useContext(SelectedDateContext);
